import { useState } from "react";
import { API_URL } from "../../utils/common";

// INTERFACES
export interface CatalogoBase {
    id?: number;
    nombre: string;
    activo?: boolean;
}

export interface TipoAplicacion extends CatalogoBase { }
export interface FormatoBanner extends CatalogoBase { }
export interface TipoVistaBanner extends CatalogoBase { }
export interface TituloMarquee extends CatalogoBase { }

export interface TipoBanner {
    nombre: string;
    tipoAplicacion: string;
    pixelaje: string | null;
    formatoAdmitido: string | null;
    modoDespliegue: string | null;
}

// HOOK
export const useCatalogosBanners = () => {

    // LOADING INDEPENDIENTE
    const [loadingTiposAplicacion, setLoadingTiposAplicacion] = useState(false);
    const [loadingTipos, setLoadingTipos] = useState(false);
    const [loadingFormatos, setLoadingFormatos] = useState(false);
    const [loadingTiposVista, setLoadingTiposVista] = useState(false);
    const [loadingTitulosMarquee, setLoadingTitulosMarquee] = useState(false);

    // ERROR INDEPENDIENTE

    const [errorTiposAplicacion, setErrorTiposAplicacion] = useState<string | null>(null);
    const [errorTipos, setErrorTipos] = useState<string | null>(null);
    const [errorFormatos, setErrorFormatos] = useState<string | null>(null);
    const [errorTiposVista, setErrorTiposVista] = useState<string | null>(null);
    const [errorTitulosMarquee, setErrorTitulosMarquee] = useState<string | null>(null);

    // TOKEN

    const getToken = () => localStorage.getItem("jwt");

    // TIPOS APLICACIÓN
    // GET /cms/catalogos/tipos-aplicacion


    const obtenerTiposAplicacion =
        async (): Promise<TipoAplicacion[]> => {

            setLoadingTiposAplicacion(true);
            setErrorTiposAplicacion(null);

            try {

                const token = getToken();

                if (!token) {
                    throw new Error("Token no encontrado");
                }

                const response = await fetch(
                    `${API_URL}/cms/catalogos/tipos-aplicacion`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error(
                        `Error ${response.status} al obtener los tipos de aplicación`
                    );
                }

                const data: TipoAplicacion[] =
                    await response.json();

                return data;

            } catch (err: any) {

                console.error(
                    "Error tipos aplicación:",
                    err
                );

                setErrorTiposAplicacion(
                    err.message || "Ocurrió un error"
                );

                return [];

            } finally {

                setLoadingTiposAplicacion(false);

            }
        };



    // TIPOS BANNER
    // GET /cms/catalogos/tipos
    // GET /cms/catalogos/tipos?tipoAplicacion=IZZI APPS


    const obtenerTipos = async (
        tipoAplicacion?: string
    ): Promise<TipoBanner[]> => {

        setLoadingTipos(true);
        setErrorTipos(null);

        try {

            const token = getToken();

            if (!token) {
                throw new Error("Token no encontrado");
            }

            let url =
                `${API_URL}/cms/catalogos/tipos`;

            if (tipoAplicacion) {

                url +=
                    `?tipoAplicacion=${encodeURIComponent(
                        tipoAplicacion
                    )}`;

            }

            const response = await fetch(
                url,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (!response.ok) {
                throw new Error(
                    `Error ${response.status} al obtener los tipos de banner`
                );
            }

            const data: TipoBanner[] =
                await response.json();

            return data;

        } catch (err: any) {

            console.error(
                "Error tipos banner:",
                err
            );

            setErrorTipos(
                err.message || "Ocurrió un error"
            );

            return [];

        } finally {

            setLoadingTipos(false);

        }
    };

    // FORMATOS
    // GET /cms/catalogos/formatos

    const obtenerFormatos =
        async (): Promise<FormatoBanner[]> => {

            setLoadingFormatos(true);
            setErrorFormatos(null);

            try {

                const token = getToken();

                if (!token) {
                    throw new Error("Token no encontrado");
                }

                const response = await fetch(
                    `${API_URL}/cms/catalogos/formatos`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error(
                        `Error ${response.status} al obtener los formatos`
                    );
                }

                const data: FormatoBanner[] =
                    await response.json();

                return data;

            } catch (err: any) {

                console.error(
                    "Error formatos:",
                    err
                );

                setErrorFormatos(
                    err.message || "Ocurrió un error"
                );

                return [];

            } finally {

                setLoadingFormatos(false);

            }
        };



    // TIPOS VISTA
    // GET /cms/catalogos/tipos-vista


    const obtenerTiposVista =
        async (): Promise<TipoVistaBanner[]> => {

            setLoadingTiposVista(true);
            setErrorTiposVista(null);

            try {

                const token = getToken();

                if (!token) {
                    throw new Error("Token no encontrado");
                }

                const response = await fetch(
                    `${API_URL}/cms/catalogos/tipos-vista`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error(
                        `Error ${response.status} al obtener los tipos de vista`
                    );
                }

                const data: TipoVistaBanner[] =
                    await response.json();

                return data;

            } catch (err: any) {

                console.error(
                    "Error tipos vista:",
                    err
                );

                setErrorTiposVista(
                    err.message || "Ocurrió un error"
                );

                return [];

            } finally {

                setLoadingTiposVista(false);

            }
        };



    // TITULOS MARQUEE
    // GET /cms/catalogos/titulos-marquee
    const obtenerTitulosMarquee =
        async (): Promise<TituloMarquee[]> => {

            setLoadingTitulosMarquee(true);
            setErrorTitulosMarquee(null);

            try {

                const token = getToken();

                if (!token) {
                    throw new Error("Token no encontrado");
                }

                const response = await fetch(
                    `${API_URL}/cms/catalogos/titulos-marquee`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error(
                        `Error ${response.status} al obtener los títulos marquee`
                    );
                }

                const data: TituloMarquee[] =
                    await response.json();

                return data;

            } catch (err: any) {

                console.error(
                    "Error títulos marquee:",
                    err
                );

                setErrorTitulosMarquee(
                    err.message || "Ocurrió un error"
                );

                return [];

            } finally {

                setLoadingTitulosMarquee(false);

            }
        };

    // RETURN

    return {

        // FUNCIONES
        obtenerTiposAplicacion,
        obtenerTipos,
        obtenerFormatos,
        obtenerTiposVista,
        obtenerTitulosMarquee,

        // LOADING INDEPENDIENTES
        loadingTiposAplicacion,
        loadingTipos,
        loadingFormatos,
        loadingTiposVista,
        loadingTitulosMarquee,

        // ERRORES INDEPENDIENTES
        errorTiposAplicacion,
        errorTipos,
        errorFormatos,
        errorTiposVista,
        errorTitulosMarquee,

    };

};